<div class="header-injector" id="header-injector-widget" tabindex="0" aria-label="Header Injector widget" role="navigation">
  <div class="header-injector__wrapper">
    <div class="header-injector__inner">
      <p id="header-injector-text" class="header-injector__text"></p>
      <div class="header-injector__controls">
        <button
          class="header-injector__btn-header-edit"
          id="header-injector-edit-btn"
          type="button">
          <span>Header:</span>
          <span id="header-injector-header-value"></span>
          <svg width="18px" height="18px" viewBox="0 0 24 24" stroke-width="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M14.3632 5.65156L15.8431 4.17157C16.6242 3.39052 17.8905 3.39052 18.6716 4.17157L20.0858 5.58579C20.8668 6.36683 20.8668 7.63316 20.0858 8.41421L18.6058 9.8942M14.3632 5.65156L4.74749 15.2672C4.41542 15.5993 4.21079 16.0376 4.16947 16.5054L3.92738 19.2459C3.87261 19.8659 4.39148 20.3848 5.0115 20.33L7.75191 20.0879C8.21972 20.0466 8.65806 19.8419 8.99013 19.5099L18.6058 9.8942M14.3632 5.65156L18.6058 9.8942" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <form id="header-injector-form" class="header-injector__form" autofocus>
          <span>Header:</span>
          <input
            id="header-injector__input"
            type="text"
            name="header-injector__input"
            class="header-injector__input"
            title="Allowed characters: A-Z, a-z, 0-9, _, -"
            pattern="[A-Za-z0-9_\-]+"
            maxlength="16"
            placeholder="e.g. SO-12345"
          />
          <button
            class="header-injector-btn"
            id="header-injector-update"
            type="submit"
          >
            Set
          </button>
          <button
            class="header-injector__btn-cancel-edit header-injector-btn header-injector-btn--inverted"
            id="header-injector-cancel-btn"
            type="button"
          >
            Cancel
          </button>
        </form>

        <button
          class="header-injector__btn-link header-injector-btn"
          id="header-injector-con-btn"
          type="button"
        >
          Link on-demand BE
        </button>

        <button
          class="header-injector__btn-clear header-injector-btn"
          id="header-injector-discon-btn"
          type="button"
        >
          Clear
        </button>

        <button
          class="header-injector__btn-share header-injector-btn header-injector-btn--inverted"
          id="header-injector-share-btn"
          type="button"
        >
          Share Link
        </button>

        <a
          class="header-injector__btn-jira header-injector-btn--icon"
          id="header-injector-jira-link"
          target="_blank"
          rel="noopener"
          title="Open in Jira"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#000000"><path d="M11.571 11.513H0a5.218 5.218 0 0 0 5.232 5.215h2.13v2.057A5.215 5.215 0 0 0 12.575 24V12.518a1.005 1.005 0 0 0-1.005-1.005zm5.723-5.756H5.736a5.215 5.215 0 0 0 5.215 5.214h2.129v2.058a5.218 5.218 0 0 0 5.215 5.214V6.758a1.001 1.001 0 0 0-1.001-1.001zM23.013 0H11.455a5.215 5.215 0 0 0 5.215 5.215h2.129v2.057A5.215 5.215 0 0 0 24 12.483V1.005A1.001 1.001 0 0 0 23.013 0z"/></svg>
        </a>
      </div>
    </div>

    <a
      href="https://nova.staging.soenergy.co/admin/features-admin"
      target="_blank"
      class="header-injector__btn-feature-flags header-injector-btn--icon"
      title="Feature Flags"
    >
      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000" stroke-width="1.5"><rect x="7" y="2" width="10" height="20" rx="5" ry="5"/><circle cx="12" cy="7" r="2.5" fill="#000000"/></svg>
    </a>
    <a
      href="https://linkerd-viz.staging.soenergy.co/namespaces/staging/deployments"
      target="_blank"
      class="header-injector__btn-linkerd header-injector-btn--icon"
      title="Linkerd"
    >
      <svg width="20px" height="20px" viewBox="-1.21 12.29 504.92 469.42"><path d="M460.4 106.5v182.8l33.7 19.5V126zM8.6 308.8l33.7-19.5V106.5L8.6 126zm165.2-1.8l155.1 89.5v-38.9l-145.2-83.8-9.9 5.7zm164 141.4l-164-94.7v38.9l43.8 25.3-52.7 30.4c-3.5 2-3.5 7.2 0 9.2l25.7 14.9 60.7-35 60.7 35 25.7-14.9c3.6-1.9 3.6-7.1.1-9.1z"/><path d="M460.4 215.5v162.1c0 4.1 4.4 6.7 8 4.6l23.1-13.3c1.6-.9 2.7-2.7 2.7-4.6V196.1l-33.8 19.4zM394.2 425l21.7-12.6c2.5-1.4 4-4.1 4-6.9V238.9l-33.7 19.5v162.1c0 4 4.4 6.6 8 4.5zM312 472.5l31.1-17.9c1.6-.9 2.7-2.7 2.7-4.6V281.7L312 301.2v171.3zm-152.4-18l31.1 17.9V301.2L157 281.7v168.2c0 1.9 1 3.7 2.6 4.6zm-72.8-42l21.7 12.6c3.5 2 8-.5 8-4.6V258.3l-33.7-19.5v166.7c0 2.9 1.5 5.6 4 7zm-74.2-42.8l21.7 12.6c3.5 2 8-.5 8-4.6V215.5L8.6 196.1v166.7c0 2.8 1.5 5.4 4 6.9z"/><path d="M494.1 126l-33.7-19.5-60.7 35-40.4-23.3L412 87.8c3.5-2 3.5-7.2 0-9.2L390.2 66c-2.5-1.4-5.5-1.4-8 0l-56.7 32.7-40.4-23.3L337.8 45c3.5-2 3.5-7.2 0-9.2L316 23.2c-2.5-1.4-5.5-1.4-8 0l-56.7 32.7-56.7-32.7c-2.5-1.4-5.5-1.4-8 0l-21.8 12.6c-3.5 2-3.5 7.2 0 9.2l295.4 170.6 33.7-19.5-60.7-35 60.9-35.1zM112.5 66L90.8 78.6c-3.5 2-3.5 7.2 0 9.2l295.4 170.6 33.7-19.5L120.5 66c-2.5-1.4-5.5-1.4-8 0zM8.6 126l60.7 35-60.7 35.1 33.8 19.4 60.6-35 40.5 23.4-60.7 35 33.7 19.5 60.7-35.1 40.4 23.4-60.7 35 33.8 19.5 60.6-35.1 60.7 35.1 33.7-19.5L42.3 106.5z"/></svg>
  </a>
    <button
      class="header-injector__btn-pin header-injector-btn--icon"
      id="header-injector-autohide-btn"
      title="Toggle auto-hide"
    >
      <svg class="icon-pin-on" width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000" stroke-width="1.5"><path d="M9.5 14.5L3 21" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ></path> <path d="M5.00007 9.48528L14.1925 18.6777L15.8895 16.9806L15.4974 13.1944L21.0065 8.5211L15.1568 2.67141L10.4834 8.18034L6.69713 7.78823L5.00007 9.48528Z" fill="#000000" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ></path></svg>
      <svg class="icon-pin-off" width="20px" height="20px" viewBox="0 0 24 24" stroke-width="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000"><path d="M9.5 14.5L3 21" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ></path> <path d="M5.00007 9.48528L14.1925 18.6777L15.8895 16.9806L15.4974 13.1944L21.0065 8.5211L15.1568 2.67141L10.4834 8.18034L6.69713 7.78823L5.00007 9.48528Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ></path></svg>
  </button>
  </div>
</div>
